// Klasser för komponenten <eui-flikar> och anslutande:

// Gemensam för alla sådana här klasser på en sida, vilket är precis det vi vill:
//let uniktIdCounter = 0;


//###################################################################################################
// En enskild flikgrupp:

class flikgruppConfigClass
{
	constructor(flikar
		//,
		//// Named and optional parameters (med eventuella default satta), as options object:
		//{
		//	visas = false,
		//}
		//	= {}	// Default för den optional options-parametern som sådan.
	)
	{
		// Först lite basic typkontroller av parametrarna: ---------------------------

		// Alt: Array.isArray(flikar)
		console.assert(flikar instanceof Array,
			'Parametern \'flikar\' är obligatorisk och måste vara av typen \'Array\'.'
		);

		console.assert(flikar.every(val => val instanceof flikClass),
			'Alla värden i arrayen \'flikar\' måste vara av typen \'flikClass\'.'
		);

		// ---------------------------------------------------------------------------

		this.flikar = flikar;

		// Kolla att varje del med eventId har ett unikt sådant:
		// Todo: Detta ska ändras så att unikiteten är per eventId + eventData. Fixat snabbt med en '+' av värdena nedan:

		// SO: https://stackoverflow.com/a/30735595/593779
		// "Here, we insert each and every object's name into the Set and we check if the size before and after adding are the same. This works because Set.size returns a number based on unique data (set only adds entries if the data is unique). If/when you have duplicate names, the size won't increase (because the data won't be unique) which means that we would have already seen the current name and it will return true."

		let seen = new Set();

		// The some() method tests whether at least one element in the array passes the test implemented by the provided function:
		let hasDuplicates = this.flikar.filter((item) => { return item.eventId !== undefined; })
			.some((currentObject) =>
				{
					return seen.size === seen.add(currentObject.eventId + JSON.stringify(currentObject.eventData)).size;
				}
			);

		console.assert(!hasDuplicates,
			'Det finns minst en flik som har ett icke-unikt event-id (i kombination med event-data).',
			this.flikar
		);

		this.uppdateraFlikindex();
	}

	// ==========================================================

	// Static method för att efterlikna copy constructor/cast (från ett korrekt object som dock bara inte är av typen flikgruppConfigClass):
	// Obs! Denna "castar" *endast* rotobjektet, inte nästade underobjekt/arrayvärden.
	static castFrom(obj)
	{
		// Obs! Denna borde *egentligen* hantera nästade objekt/arrayvärden (flikClass), se euiPopUpMenyClasses, men eftersom undertypen i sig endast är ett POCO utan metoder e.d. så behövs det inte riktigt, så vi skjuter det på framtiden!

		let ny = new flikgruppConfigClass([]);		// [] här för parameterkontrollen (obligatorisk) ovan.
		ny = Object.assign(ny, obj);
		ny.uppdateraFlikindex();
		return ny;
	}

	// ==========================================================

	uppdateraFlikindex()
	{
		for (let i = 0; i < this.antalFlikar; i++)
		{
			this.flikar[i].index = i;
		}
	}

	valjFlikMedIndex(valdIndex)
	{
		if (valdIndex >= 0)
		{
			// Om inte undefined:
			for (let i = 0; i < this.antalFlikar; i++)
			{
				this.flikar[i].vald = (i === valdIndex);
			}
		}
	}

	get antalFlikar()
	{
		return this.flikar.length;
	}
}


//###################################################################################################
// En enskild flik:

class flikClass
{
	constructor(
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			text,			// undefined => ingen text.
			ikon,			// undefined => ingen ikon.
			eventId,
			eventData,
			disabled = false,
			tooltip,
			vald = false,
			arGhost = false,
			hidden = false,
			menyConfig = undefined,			// undefined => ingen mermeny i fliken.
		}
			= {}	// Default för den optional options-parametern som sådan.
	)
	{
		this.text = text;
		this.ikon = ikon;
		this.eventId = eventId;
		this.eventData = eventData;
		this.disabled = disabled;
		this.tooltip = tooltip;
		this.vald = vald;
		this.arGhost = arGhost;
		this.hidden = hidden;
		this.menyConfig = menyConfig;

		this.index = undefined;		// Denna sätts när en array med flikar används i flikgruppConfigClass, av dess constructor!
	}

	// ==========================================================

	// Static method för att efterlikna copy constructor/cast (från ett korrekt object som dock bara inte är av typen flikClass):
	// Obs! Denna "castar" *endast* rotobjektet, inte nästade underobjekt/arrayvärden (för sådana förekommer inte i denna class).
	static castFrom(obj)
	{
		let ny = new flikClass();
		ny = Object.assign(ny, obj);
		return ny;
	}
}


//###################################################################################################


export default {
	flikgruppConfig: flikgruppConfigClass,
	flik: flikClass,
}

